import { Layout, Menu, Dropdown, Avatar, Space, Typography } from 'antd';
import { UserOutlined, LogoutOutlined, FileTextOutlined, HomeOutlined, BookOutlined, TeamOutlined, ExperimentOutlined } from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth';

const { Header, Content } = Layout;
const { Text } = Typography;

export function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: (
        <div>
          <div style={{ fontWeight: 500 }}>{user?.attributes?.name || user?.username}</div>
          <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{user?.attributes?.email}</div>
          <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
            {user?.attributes?.['custom:group']} • {user?.attributes?.['custom:tenant_id']}
          </div>
        </div>
      ),
      disabled: true,
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout,
    },
  ];

  const mainMenuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: 'Dashboard',
      onClick: () => navigate('/'),
    },
    {
      key: '/mappings',
      icon: <FileTextOutlined />,
      label: 'Mappings',
      onClick: () => navigate('/mappings'),
    },
    {
      key: '/doctypes',
      icon: <BookOutlined />,
      label: 'Doc Types',
      onClick: () => navigate('/doctypes'),
    },
    {
      key: '/tenants',
      icon: <TeamOutlined />,
      label: 'Tenants',
      onClick: () => navigate('/tenants'),
    },
    {
      key: '/lab',
      icon: <ExperimentOutlined />,
      label: 'Lab',
      onClick: () => navigate('/lab'),
    },
  ];

  const selectedKeys = mainMenuItems
    .filter((item) => location.pathname.startsWith(item.key))
    .map((item) => item.key);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{
        background: '#fff',
        padding: '0 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
          <Typography.Title level={4} style={{ margin: 0, color: '#1890ff' }}>
            Mapper UI
          </Typography.Title>

          <Menu
            mode="horizontal"
            selectedKeys={selectedKeys}
            items={mainMenuItems}
            style={{
              border: 'none',
              background: 'transparent',
              minWidth: '450px'
            }}
          />
        </div>

        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Space style={{ cursor: 'pointer' }}>
            <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
            <Text>{user?.attributes?.name || user?.username}</Text>
          </Space>
        </Dropdown>
      </Header>

      <Content style={{ padding: '24px', background: '#f0f2f5' }}>
        <div style={{
          background: '#fff',
          padding: '24px',
          borderRadius: '8px',
          minHeight: 'calc(100vh - 112px)'
        }}>
          <Outlet />
        </div>
      </Content>
    </Layout>
  );
}
